import { css } from 'styled-components';

export const DatePickerStylesCustomization = css`
  .react-datepicker__day--selected,
  .react-datepicker__day--in-selecting-range,
  .react-datepicker__day--in-range,
  .react-datepicker__month-text--selected,
  .react-datepicker__month-text--in-selecting-range,
  .react-datepicker__month-text--in-range,
  .react-datepicker__quarter-text--selected,
  .react-datepicker__quarter-text--in-selecting-range,
  .react-datepicker__quarter-text--in-range,
  .react-datepicker__year-text--selected,
  .react-datepicker__year-text--in-selecting-range,
  .react-datepicker__year-text--in-range {
    background-color: ${({ theme }) => theme.colors.orange500} !important;
  }
  .react-datepicker__day--selected:hover,
  .react-datepicker__day--in-selecting-range:hover,
  .react-datepicker__day--in-range:hover,
  .react-datepicker__month-text--selected:hover,
  .react-datepicker__month-text--in-selecting-range:hover,
  .react-datepicker__month-text--in-range:hover,
  .react-datepicker__quarter-text--selected:hover,
  .react-datepicker__quarter-text--in-selecting-range:hover,
  .react-datepicker__quarter-text--in-range:hover,
  .react-datepicker__year-text--selected:hover,
  .react-datepicker__year-text--in-selecting-range:hover,
  .react-datepicker__year-text--in-range:hover {
    background-color: ${({ theme }) => theme.colors.orange500} !important;
  }
  .react-datepicker__current-month,
  .react-datepicker-time__header,
  .react-datepicker-year-header {
    color: ${({ theme }) => theme.colors.onPrimary} !important;
  }
  .react-datepicker__header {
    background-color: ${({ theme }) => theme.colors.orange500} !important;
  }
  .react-datepicker {
    font-family: inherit !important;
    font-size: inherit !important;
    background-color: ${({ theme }) => theme.colors.onPrimary}!important;
    color: ${({ theme }) => theme.colors.onSurface}!important;
    border: 1px solid ${({ theme }) => theme.colors.orange500}!important;
  }

  .react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle {
    fill: ${({ theme }) => theme.colors.onPrimary}!important;
    color: ${({ theme }) => theme.colors.onPrimary}!important;
  }
  .react-datepicker-popper .react-datepicker__triangle {
    stroke: ${({ theme }) => theme.colors.orange500} !important;
  }
  .react-datepicker__year-read-view--down-arrow,
  .react-datepicker__month-read-view--down-arrow,
  .react-datepicker__month-year-read-view--down-arrow,
  .react-datepicker__navigation-icon::before {
    border-color: ${({ theme }) => theme.colors.onPrimary} !important;
  }
  .react-datepicker__day-names {
    color: ${({ theme }) => theme.colors.onPrimary}!important;
  }
  .react-datepicker__year-read-view--selected-year {
    color: ${({ theme }) => theme.colors.onPrimary}!important;
  }

  .react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle {
    fill: ${({ theme }) => theme.colors.orange500} !important;
    color: ${({ theme }) => theme.colors.orange500} !important;
  }
`;
